export default __webpack_public_path__ + "static/fast_turtles-d9b9ec52aeec83ad28ea733d79393eca.png";